import {
  border,
  breakpoints,
  colors,
  darkColors,
  primaryFont,
  radius,
  secondaryFont,
  shadow,
  spacing,
} from './typescriptTokens';
import { DefaultTheme } from 'styled-components';

export const explorationBrandRefreshTheme: DefaultTheme = {
  font: {
    primary: primaryFont,
    secondary: secondaryFont,
  },
  fontWeight: {
    primary: {
      heavy: '700',
      semi: '600',
      medium: '500',
      reg: '400',
      light: '300',
    },
  },
  size: {
    mini: 10,
    '1': 12,
    '2': 14,
    '3': 16,
    '4': 18,
    '5': 20,
    '6': 22,
    '7': 24,
    '8': 28,
    '9': 32,
    '10': 36,
    '11': 40,
    '12': 48,
    '13': 54,
    '14': 60,
    '15': 68,
    '16': 76,
    '17': 84,
    '18': 96,
  },
  lineHeight: {
    xxxxs: 14,
    xxxs: 16,
    xxs: 18,
    xs: 20,
    s: 22,
    m: 24,
    l: 28,
    xl: 32,
    xxl: 40,
    xxxl: 44,
    xxxxl: 48,
    xxxxxl: 52,
    xxxxxxl: 56,
    xxxxxxxl: 72,
    mini: 14,
    default: 16,
  },
  spacing: spacing,
  shadow: shadow,
  radius: radius,
  breakpoints: breakpoints,
  midwestColors: colors,
  border: border,
};

export const explorationDarkTheme: DefaultTheme = {
  font: {
    primary: primaryFont,
    secondary: secondaryFont,
  },
  fontWeight: {
    primary: {
      heavy: '700',
      semi: '600',
      medium: '500',
      reg: '400',
      light: '300',
    },
  },
  size: {
    mini: 10,
    '1': 12,
    '2': 14,
    '3': 16,
    '4': 18,
    '5': 20,
    '6': 22,
    '7': 24,
    '8': 28,
    '9': 32,
    '10': 36,
    '11': 40,
    '12': 48,
    '13': 54,
    '14': 60,
    '15': 68,
    '16': 76,
    '17': 84,
    '18': 96,
  },
  lineHeight: {
    xxxxs: 14,
    xxxs: 16,
    xxs: 18,
    xs: 20,
    s: 22,
    m: 24,
    l: 28,
    xl: 32,
    xxl: 40,
    xxxl: 44,
    xxxxl: 48,
    xxxxxl: 52,
    xxxxxxl: 56,
    xxxxxxxl: 72,
    mini: 14,
    default: 16,
  },
  spacing: spacing,
  shadow: shadow,
  radius: radius,
  breakpoints: breakpoints,
  midwestColors: darkColors,
  border: border,
};

export * from './typography/midwestTextStyles';

export * from './theme';
